import { render, staticRenderFns } from "./SelectParts.vue?vue&type=template&id=065d2658&"
import script from "./SelectParts.vue?vue&type=script&lang=js&"
export * from "./SelectParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports